import { email, required, requiredIf } from 'vuelidate/lib/validators'
import appCustomTextConst from '@/pages/application/const/applicationCustomTextConst'
import { ebisResidencyNoExpiryStatuses } from '@/pages/application/const/applicationConst'
import Cookies from 'js-cookie'
import configAdmin from '@/config/configAdmin'

const preSchools = {
  optIncome: ['Below $50,000', '$50,000 - $100,000', 'Above $100,000'],
  schoolsInfo: [
    {
      school: 'Beach',
      schoolID: 'SCH201500000074',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/islander/fees/',
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_ISLANDER_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '451-303-355-3',
        branchCode: '7375 / 001',
        registrationFee: '$654',
        remarks: "Bank Charges shall be borne by remitter. Please indicate your child's full name and Beach during wire transfer.",
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_beach_TC_2024.pdf',
    },
    {
      school: 'Gardens',
      schoolID: 'SCH202200000680',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/gardens/fees/',
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_GARDENS_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '208-312-520-0',
        branchCode: '7375 / 059',
        registrationFee: '$1,308',
        remarks: 'Bank Charges shall be borne by the remitter. Please indicate “Gardens” and your child’s full name during wire transfer.',
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_garden_TC_2024.pdf',
    },
    {
      school: 'Mountbatten 223',
      schoolID: 'SCH201400000480',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/mountbatten223/fees/',
      langState: {
        title: 'Languages',
        ddlAddLanguage: ['Malay', 'Hindi', 'Tamil', 'Japanese'],
        hideEAL: true,
        remark: '*Selection of Additional Language is optional, and subject to placement availability.',
      },
      addInfo:
        "EtonHouse Pre-School @ Mountbatten 223 provides school bus service. Kindly check with the school's Parent Liaison Team about the appointed transport service provider and their fees.",
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_M223_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '208-312-520-0',
        branchCode: '7375 / 059',
        registrationFee: '$654',
        remarks: "Bank Charges shall be borne by remitter. Please indicate your child's full name and Mountbatten 223 during wire transfer.",
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_M223_TC_2024.pdf',
    },
    {
      school: 'Nature',
      schoolID: 'SCH202300000663',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/nature-preschool/fees/',
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_M718_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '208–312-520-0',
        branchCode: '7375 / 059',
        registrationFee: '$2,180',
        remarks: "Bank Charges shall be borne by remitter. Please indicate your child's full name and Nature during wire transfer.",
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_nature_TC_2024.pdf',
    },
    {
      school: 'Newton',
      schoolID: 'SCH201400000471',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/newton/fees/',
      langState: {
        title: 'Preferred Languages Programme',
        ddlLanguage: {
          Bilingual: 'Bilingual',
          Mandarin: 'EtonHouse ZhongHua Mandarin Immersion Programme (PN - N2 Year Levels)',
        },
        additionalLangLabel: 'Additional Language: Japanese (for native speaking families only) ',
        ddlAddLanguage: ['Japanese'],
        hideEAL: true,
      },
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_NEWTON_PAYNOW.pdf',
      addInfo:
        "EtonHouse Newton Pre-School provides school bus service. Kindly check with the school's Parent Liaison Team about the appointed transport service provider and their fees.",
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '208-312-520-0',
        branchCode: '7375 / 059',
        registrationFee: '$2,180',
        remarks: 'Bank Charges shall be borne by remitter. Please indicate “Newton” and your child’s full name during the wire transfer.',
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_newton_TC_2024.pdf',
    },
    {
      school: 'City',
      schoolID: 'SCH201400000497',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/quayside-preschool/fees/',
      langState: {
        title: 'Preferred Languages Programme',
        hideEAL: true,
        ddlLanguage: {
          Bilingual: 'Bilingual',
          Mandarin: 'EtonHouse ZhongHua Mandarin Immersion Programme',
        },
        ddlAddLanguage: ['Japanese'],
        additionalLangLabel: 'Additional Language: Japanese (for native speaking families only) ',
      },
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_CITY_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse International Research Pre-School Pte Ltd',
        bankName: `DBS Bank`,
        bankCode: `DBSSSGSG`,
        bankAcc: '072-005-041-0',
        branchCode: '7171 / 072',
        registrationFee: '$1,308',
        remarks: 'Bank Charges shall be borne by remitter. Please indicate “City” and your child’s full name during the wire transfer.',
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_City_TC_2025.pdf',
    },
    {
      school: '215 Upper Bukit Timah',
      schoolID: 'SCH201500000032',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/upper-bukit-timah/fees/',
      langState: {
        title: 'Preferred Languages Programme',
        hideEAL: true,
        ddlLanguage: {
          Bilingual: 'Bilingual',
          Mandarin: 'EtonHouse ZhongHua Mandarin Immersion Programme',
        },
      },
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_215UBT_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse Bilingual Pre-School Pte Ltd',
        bankAcc: '451-301-121-5',
        branchCode: '7375 / 001',
        registrationFee: '$654',
        remarks: "Bank Charges shall be borne by remitter. Please indicate your child's full name and 215 Upper Bukit Timah during wire transfer.",
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_215UBT_TC_2024.pdf',
    },
    {
      school: 'Vanda',
      schoolID: 'SCH201400000501',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/vanda/fees/',
      langState: {
        title: 'Preferred Languages Programme',
        hideEAL: true,
        ddlLanguage: {
          Bilingual: 'Bilingual',
          Mandarin: 'EtonHouse ZhongHua Mandarin Immersion Programme',
        },
      },
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_VANDA_PAYNOW.pdf',
      addInfo:
        "EtonHouse Pre-School Vanda provides school bus service. Kindly check with the school's Parent Liaison Team about the appointed transport service provider and their fees.",
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '208-312-520-0',
        branchCode: '7375 / 059',
        registrationFee: '$654',
        remarks: "Bank Charges shall be borne by remitter. Please indicate your child's full name and Vanda during wire transfer.",
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_vanda_TC_2024.pdf',
    },
    {
      school: 'Zhong Hua',
      schoolID: 'SCH201500000054',
      fees: '',
      feeURL: 'https://www.etonhouse.edu.sg/school/zhong-hua/fees/',
      paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_ZHONGHUA_PAYNOW.pdf',
      paymentInfo: {
        Beneficial: 'EtonHouse Pre-School Pte Ltd',
        bankAcc: '375-300-648-4',
        branchCode: '7375 / 059',
        registrationFee: '$654',
        remarks: 'Bank Charges shall be borne by remitter. Please indicate “ZH” and your child’s full name during the wire transfer.',
      },
      termInfo: 'https://kws.etonhouse.com/images/PRE_zhonghua_TC_2024.pdf',
    },
  ],
  currentSchoolDropdown: [
    { SchoolID: 'SCH201700000431', SchoolName: 'Orchard' },
    { SchoolID: 'SCH201300000254', SchoolName: 'Broadrick' },
    { SchoolID: 'SCH201500000043', SchoolName: 'Sentosa' },
    { SchoolID: 'SCH201700000394', SchoolName: 'Sentosa Primary' },
    { SchoolID: 'SCH201400000541', SchoolName: 'Claymore' },
    { SchoolID: 'SCH202200000680', SchoolName: 'Gardens' },
    { SchoolID: 'SCH201400000497', SchoolName: 'City' },
    { SchoolID: 'SCH201500000032', SchoolName: '215 Upper Bukit Timah' },
    { SchoolID: 'SCH201400000501', SchoolName: 'Vanda' },
    { SchoolID: 'SCH201500000054', SchoolName: 'Zhong Hua' },
    { SchoolID: 'SCH201800000510', SchoolName: 'Middleton Tampines' },
    { SchoolID: 'SCH202300000690', SchoolName: 'Middleton West Coast' },
    { SchoolID: 'SCH202100000591', SchoolName: 'Middleton Pre-Sch West Coast' },
    { SchoolID: 'SCH201500000074', SchoolName: 'Islander' },
    { SchoolID: 'SCH201400000471', SchoolName: 'Newton' },
    { SchoolID: 'SCH202300000663', SchoolName: 'Nature' },
    { SchoolID: 'SCH201400000480', SchoolName: 'Mountbatten 223' },
  ],
}
const ehSchoolsData = {
  Claymore: {
    paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_CLAYMORE_PAYNOW.pdf',
    paymentInfo: {
      Beneficial: 'EtonHouse International Pre-School Pte Ltd',
      bankAcc: '451-301-511-3',
      branchCode: '7375 / 001',
      bankName: 'United Overseas Bank Ltd',
      bankAddress: '80 Raffles Place, UOB Plaza 1 Singapore 048624',
      swiftCode: 'UOVBSGSG',
      text: `<strong>Bank Details (Wire Transfer)</strong>: Bank Charges shall be borne by remitter. <br/> Kindly indicate your child's full name and Claymore during wire transfer.`,
    },
    schoolID: 'SCH201400000541',
  },
  Broadrick: {
    paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_BROADRICK_PAYNOW.pdf',
    paymentInfo: {
      Beneficial: 'EtonHouse International School Pte Ltd',
      bankAcc: '003-908296-7',
      branchCode: '7171 / 00',
      bankName: 'DBS Bank Ltd',
      swiftCode: 'DBSSSGSG – For overseas transfer',
      text: `<strong>Bank Details (Wire Transfer)</strong>: Bank Charges shall be borne by remitter. Please indicate your child’s full name during wire transfer.<br/>`,
    },
  },
  'Sentosa Primary': {
    paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_SENTOSA_PRIMARY_PAYNOW.pdf',
    paymentInfo: {
      Beneficial: 'EtonHouse International School Pte Ltd',
      bankAcc: '003-908296-7',
      branchCode: '7171 / 00',
      bankName: 'DBS Bank Ltd',
      swiftCode: 'DBSSSGSG – For overseas transfer',
      text: `<strong>Bank Details (Wire Transfer)</strong>: Bank Charges shall be borne by remitter. Please indicate your child’s full name during wire transfer.<br/>`,
    },
  },
  Orchard: {
    paynowQrImage: 'https://kws.etonhouse.com/images/ETONHOUSE_ORCHARD_PAYNOW.pdf',
    paymentInfo: {
      Beneficial: 'EtonHouse International School Pte Ltd',
      bankAcc: '107-308-882-3',
      branchCode: '7375 / 007',
      bankName: 'United Overseas Bank Limited',
      swiftCode: 'UOVBSGSG – For overseas transfer',
      bankBranch: '(007) UOB Thomson',
      text: `<strong>Bank Details (Wire Transfer)</strong>: Bank Charges shall be borne by remitter. Please indicate your child’s full name during wire transfer.<br/>`,
    },
  },
}
const schools = {
  Broadrick: 'SCH201300000254',
  Orchard: 'SCH201700000431',
}
const preSchoolsDropdown = {
  Gardens: 'SCH202200000680',
  'Mountbatten 223': 'SCH201400000480',
  Nature: 'SCH202300000663',
  Newton: 'SCH201400000471',
  City: 'SCH201400000497',
  '215 Upper Bukit Timah': 'SCH201500000032',
  Vanda: 'SCH201400000501',
  'Zhong Hua': 'SCH201500000054',
  'Pre-School by the Beach': 'SCH201500000074',
}

const middletonSchools = {
  Tampines: 'SCH201800000510',
}

const EIS_SCHOOLS = {
  Bhutan: 'SCH202600000102',
}

const steps = [
  { title: 'Step 1', desc: 'Student Details' },
  { title: 'Step 2', desc: 'Parent(s) or Local Guardian Details' },
  { title: 'Step 3', desc: 'Supporting Infomation' },
  { title: 'Step 4', desc: 'Declaration and Agreement' },
  { title: 'Step 5', desc: 'Attachment' },
  { title: 'Step 6', desc: 'Others' },
]

const misSteps = [
  { title: 'Step 1', desc: 'Student Details' },
  { title: 'Step 2', desc: 'Parent(s) or Local Guardian Details' },
  { title: 'Step 3', desc: 'Supporting Infomation' },
  { title: 'Step 4', desc: 'Attachment' },
  { title: 'Step 5', desc: 'Others' },
]

const ebisSteps = [
  { title: 'Step 1', desc: 'Student Details' },
  { title: 'Step 2', desc: 'Parent(s) or Local Guardian Details' },
  { title: 'Step 3', desc: 'Supporting Infomation' },
  { title: 'Step 4', desc: 'Attachment' },
  { title: 'Step 5', desc: 'Others' },
]

const getValidationMessageFromKey = function (key) {
  const data = {
    selectOptSchool: `Please select a school.`,
    studFirstName: `First Name is required.`,
    studLastName: `Last Name is required.`,
    APF_Preferred_Name: `Preferred Name is required.`,
    studDOB: `Date of Birth is required.`,
    inputFirstCommencementDate: `Commencement Date is required.`,
    studGender: `Gender is required.`,
    studCOB: `Country of Birth is required.`,
    studNationality: `Nationality is required.`,
    studCurrentSchName: `Current school name is required.`,
    studCurrentSchCountry: `Current school country is required.`,
    studIsEnrolled: `Has your child been enrolled with EtonHouse previously is required.`,
    studPassApplication: `Please indicate whether your child need to apply student pass.`,
    studImmigrationStatus: `Immigration Status is required.`,
    studImmigrationStatusNo: `Passport/NRIC/FIN/Birth Certificate No. is required.`,
    studImmigrationStatusNoExpiryDate: `Immigration document expirty date is required.`,
    studFirstLanguage: `First(1st) Language is required.`,
    studImmigrationStatusNoIssueDate: `Residency document issue date is required.`,
    uploadedStuImg: `Student image is required.`,
    passportNumber: `Passport number is required.`,
    passportExpiryDate: `Passport expiry date is required.`,
    selectOptParent: `Parent Selection is required.`,
    faFirstName: `Father's First Name is required.`,
    faLastName: `Father's Last Name is required.`,
    faNationality: `Father's Nationality is required.`,
    billEmail: `Valid billing email is required.`,
    faEmail: `Father's Email is required.`,
    faTelM: `Father's Tel (M) is required.`,
    faResidencyDocNo: `Father's residency document No. is required.`,
    faResidencyStatus: `Father's type of residency is required.`,
    faResidencyDocExpiry: `Father's residency document expiry date is required.`,
    faCompanyName: `Father's Company Name is required.`,
    maCompanyName: `Mother's Company Name is required.`,
    faOccupation: `Father's Occupation is required.`,
    maOccupation: `Mother's Occupation is required.`,
    maFirstName: `Mother's First Name is required.`,
    maLastName: `Mother's Last Name is required.`,
    maNationality: `Mother's Nationality is required.`,
    maEmail: `Mother's Email is required.`,
    maTelM: `Mother's Tel (M) is required.`,
    maResidencyDocNo: `Mother's residency document No. is required.`,
    maResidencyStatus: `Mother's type of residency is required.`,
    maResidencyExpiry: `Mother's residency document expiry date is required.`,
    maResidencyDocExpiry: `Mother's residency document expiry date is required.`,
    emgPerson1: `Emergency Contact Name is required.`,
    emgRelationship1: `Emergency Contact Relationship is required.`,
    emgTelM1: `Emergency Contact Tel (M) is required.`,
    corrResidingType: `Student will be residing with is required.`,
    corrAddress: `Address in Singapore is required.`,
    siSignatureName: `Supporting Information Signature Name is required.`,
    siSignature: `Supporting Information Signature is required.`,
    siSignatureDate: `Supporting Information Signature date is required.`,
    daSignatureName: `Declare & Agreement Signature Name is required.`,
    daSignature: `Declare & Agreement Signature is required.`,
    daSignatureDate: `Declare & Agreement Signature date is required.`,
    arrChecklistAttach: appCustomTextConst[`Please check all the required documents are uploaded.`],
    apat_ids: appCustomTextConst[`Please check all the required documents are uploaded.`],
    questionAryObj: `Please check all the required Q&A questions are answered.`,
    englishReading: `Please indicate English reading proficiency level.`,
    englishSpeaking: `Please indicate English speaking proficiency level.`,
    englishWriting: `Please indicate English writing proficiency level.`,
    additionalLangValue: `Please indicate the additional language.`,
    agreeCounselling: `Please read and acknowledge my understanding of the Pre Course Counselling information.`,
    agreeTerms: `Please read and acknowledge the MIS Terms and Conditions.`,
    agreeTerms2: `Please read and acknowledge the MIS Terms and Conditions.`,
    agreeDocument: `Please acknowledge that all documents and information provided are certified true.`,
    agreeWaitList: `Please read and acknowledge the waitlist agreement.`,
    langValue: `Language is required.`,
    billAddressPostal: `Postal Code is required.`,
    billAddressCountry: `Country is required.`,
    agreeEcda: `You need to agree share information with ECDA to proceed.`,
  }
  return data[key] ?? `${key} is required.`
}

const hasFather = function () {
  return this.selectOptParent === 'father' || this.selectOptParent === 'fnm'
}
const hasMother = function () {
  return this.selectOptParent === 'mother' || this.selectOptParent === 'fnm'
}
const studIsResident = function () {
  return this.studPassApplication === 'no'
}
// EBIS: every residency status except the ones flagged as "no supporting document"
// (e.g. Bhutanese Citizen) requires an expiry date to be provided.
const ebisResidencyRequiresExpiry = function (status) {
  return Boolean(status) && !ebisResidencyNoExpiryStatuses.includes(status)
}

const hasDoc = function (arr, type) {
  return arr.some(x => x.attType === type)
}
const sharedValidations = {
  selectOptSchool: { required },
  studFirstName: { required },
  studLastName: { required },
  studDOB: { required },
  inputFirstCommencementDate: { required },
  studGender: { required },
  studCOB: { required },
  studNationality: { required },
  studIsEnrolled: { required },
  studImmigrationStatus: { requiredIf: requiredIf(studIsResident) },
  studImmigrationStatusNo: { required },
  studFirstLanguage: { required },
  faFirstName: { requiredIf: requiredIf(hasFather) },
  faLastName: { requiredIf: requiredIf(hasFather) },
  faNationality: { requiredIf: requiredIf(hasFather) },
  faEmail: { requiredIf: requiredIf(hasFather), email },
  faTelM: { requiredIf: requiredIf(hasFather) },
  faResidencyDocNo: { requiredIf: requiredIf(hasFather) },
  maFirstName: { requiredIf: requiredIf(hasMother) },
  maLastName: { requiredIf: requiredIf(hasMother) },
  maNationality: { requiredIf: requiredIf(hasMother) },
  maEmail: { requiredIf: requiredIf(hasMother), email },
  maTelM: { requiredIf: requiredIf(hasMother) },
  maResidencyDocNo: { requiredIf: requiredIf(hasMother) },
  corrResidingType: { required },
  siSignatureName: { required },
  siSignature: { required },
  siSignatureDate: { required },
  daSignatureName: { required },
  daSignature: { required },
  daSignatureDate: { required },
  questionAryObj: {
    $each: {
      newAnswer: {
        requiredIf: requiredIf(m => (m.APFQ_Ordering >= 14 && m.APFQ_Ordering <= 21) || (m.APFQ_Ordering >= 26 && m.APFQ_Ordering <= 28)),
      },
    },
  },
}

const misQuestionIds = ['ENFQ202000000362', 'ENFQ202000000443', 'ENFQ202000000997', 'ENFQ202000000115', 'ENFQ202000000227']

const ehValidations = {
  ...sharedValidations,
  APF_Preferred_Name: { required },
  emgPerson1: { required },
  emgRelationship1: { required },
  emgTelM1: { required },
  studCurrentSchName: { required },
  corrAddress: { required },
  apat_ids: {
    hasPaymentDoc: value => {
      console.log(
        value,
        '222',
        value?.filter(x => x.attType === 'doc_payment')
      )
      return value?.filter(x => x.attType === 'doc_payment').length > 0
    },
  },
  studPassApplication: { required },
  studCurrentSchCountry: { required },
}

const clayValidations = {
  ...ehValidations,
  apat_ids: {
    hasPaymentDoc: value => hasDoc(value, 'doc_payment'),
    hasChildVaccination: value => hasDoc(value, 'doc_3'),
    hasChildPassport: value => hasDoc(value, 'doc_4'),
    hasTC: value => hasDoc(value, 'doc_9'),
  },
  questionAryObj: {
    $each: {
      newAnswer: {
        requiredIf: requiredIf(m => m.APFQ_Ordering >= 14 && m.APFQ_Ordering <= 23 && m.APFQ_Ordering !== 20),
      },
    },
  },
  agreeEcda: { required },
  faCompanyName: { requiredIf: requiredIf(hasFather) },
  maCompanyName: { requiredIf: requiredIf(hasMother) },
  faOccupation: { requiredIf: requiredIf(hasFather) },
  maOccupation: { requiredIf: requiredIf(hasMother) },
}

const preQuestionIds = [
  'ENFQ202000000953',
  'ENFQ202000000653',
  'ENFQ202000000556',
  'ENFQ202000000362',
  'ENFQ202000000443',
  'ENFQ202000000997',
  'ENFQ202000000227',
  'ENFQ202400000001',
]

const preSchoolValidations = {
  ...sharedValidations,
  corrAddress: { required },
  studPassApplication: { required },
  questionAryObj: { $each: { newAnswer: { requiredIf: requiredIf(m => preQuestionIds.includes(m.APFQ_ID)) } } },
  langValue: {
    requiredIf: requiredIf(function () {
      return this.selectOptSchool?.includes(configAdmin.schoolHex?.[0])
    }),
  },
  billAddressPostal: {
    requiredIf: requiredIf(function () {
      return this.billName
    }),
  },
  billAddressCountry: {
    requiredIf: requiredIf(function () {
      return this.billName
    }),
  },
  inputStudentEmailAdd: { email },
  validationGroupBillingEmail: ['inputStudentEmailAdd'],
  apat_ids: {
    hasPaymentDoc: value => hasDoc(value, 'doc_payment'),
    hasChildVaccination: value => hasDoc(value, 'doc_3'),
    hasChildPassport: value => hasDoc(value, 'doc_4'),
    hasTC: value => hasDoc(value, 'doc_9'),
  },
  agreeEcda: { required },
  faCompanyName: { requiredIf: requiredIf(hasFather) },
  maCompanyName: { requiredIf: requiredIf(hasMother) },
  faOccupation: { requiredIf: requiredIf(hasFather) },
  maOccupation: { requiredIf: requiredIf(hasMother) },
}

const misValidations = {
  ...sharedValidations,
  emgPerson1: { required },
  emgRelationship1: { required },
  emgTelM1: { required },
  studCurrentSchName: { required },
  englishReading: { required },
  englishSpeaking: { required },
  englishWriting: { required },
  agreeCounselling: { required },
  uploadedStuImg: { required },
  passportNumber: { required },
  passportExpiryDate: { required },
  agreeTerms: { required },
  agreeTerms2: { required },
  agreeDocument: { required },
  agreeWaitList: { required },
  studImmigrationStatus: { required },
  faResidencyStatus: { requiredIf: requiredIf(hasFather) },
  maResidencyStatus: { requiredIf: requiredIf(hasMother) },
  studImmigrationStatusNo: { requiredIf: requiredIf(studIsResident) },
  studImmigrationStatusNoExpiryDate: {
    requiredIf: requiredIf(function () {
      return this.studPassApplication === 'no' && this.studImmigrationStatus !== 'SC(Citizen)'
    }),
  },
  studImmigrationStatusNoIssueDate: {
    requiredIf: requiredIf(function () {
      return this.studImmigrationStatus === ''
    }),
  },
  questionAryObj: { $each: { newAnswer: { requiredIf: requiredIf(m => misQuestionIds.includes(m.APFQ_ID)) } } },
  selectOptParent: { required },
  apat_ids: {
    hasStuPassport: value => value.filter(x => x.attType === 'doc_stuPassport').length > 0,
    hasFatherPassport: value => value.filter(x => x.attType === 'doc_faPassport').length > 0,
    hasMotherPassport: value => value.filter(x => x.attType === 'doc_maPassport').length > 0,
    hasStuBirthCert: value => value.filter(x => x.attType === 'doc_stuBirthCert').length > 0,
    hasVaccination: value => value.filter(x => x.attType === 'doc_stuVaccination').length > 0,
  },
  studCurrentSchCountry: { required },
}

const ebisValidations = {
  ...sharedValidations,
  emgPerson1: { required },
  emgRelationship1: { required },
  emgTelM1: { required },
  studCurrentSchName: { required },
  englishReading: { required },
  englishSpeaking: { required },
  englishWriting: { required },
  uploadedStuImg: { required },
  passportNumber: { required },
  passportExpiryDate: { required },
  agreeDocument: { required },
  agreeWaitList: { required },
  studImmigrationStatus: { required },
  faResidencyStatus: { requiredIf: requiredIf(hasFather) },
  maResidencyStatus: { requiredIf: requiredIf(hasMother) },
  studImmigrationStatusNoExpiryDate: {
    requiredIf: requiredIf(function () {
      return ebisResidencyRequiresExpiry(this.studImmigrationStatus)
    }),
  },
  faResidencyDocExpiry: {
    requiredIf: requiredIf(function () {
      return hasFather.call(this) && ebisResidencyRequiresExpiry(this.faResidencyStatus)
    }),
  },
  maResidencyDocExpiry: {
    requiredIf: requiredIf(function () {
      return hasMother.call(this) && ebisResidencyRequiresExpiry(this.maResidencyStatus)
    }),
  },
  questionAryObj: { $each: { newAnswer: { requiredIf: requiredIf(m => misQuestionIds.includes(m.APFQ_ID)) } } },
  selectOptParent: { required },
  apat_ids: {
    hasStuPassport: value => value.filter(x => x.attType === 'doc_stuPassport').length > 0,
    hasFatherPassport: value => value.filter(x => x.attType === 'doc_faPassport').length > 0,
    hasMotherPassport: value => value.filter(x => x.attType === 'doc_maPassport').length > 0,
    hasStuBirthCert: value => value.filter(x => x.attType === 'doc_stuBirthCert').length > 0,
  },
  studCurrentSchCountry: { required },
}

const orchardValidations = {
  ...ehValidations,
  additionalLangValue: { required },
  questionAryObj: {
    $each: {
      newAnswer: {
        requiredIf: requiredIf(m => (m.APFQ_Ordering >= 14 && m.APFQ_Ordering <= 21) || [26, 27, 28, 30, 31]?.includes(m.APFQ_Ordering)),
      },
    },
  },
}

const beachValidations = {
  ...ehValidations,
  additionalLangValue: { required },
}

export {
  preSchools,
  preSchoolsDropdown,
  schools,
  middletonSchools,
  steps,
  misSteps,
  ebisSteps,
  getValidationMessageFromKey,
  ehValidations,
  preSchoolValidations,
  misQuestionIds,
  misValidations,
  ebisValidations,
  orchardValidations,
  beachValidations,
  ehSchoolsData,
  clayValidations,
  EIS_SCHOOLS,
}
